import { pureJsCrypto } from './js.js';
export const defaultCrypto = pureJsCrypto;
//# sourceMappingURL=index.browser.js.map